var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offline-banner"},[_vm._v(" Connection lost. Please check your internet connection ")])
}
var staticRenderFns = []

export { render, staticRenderFns }